/**
 * «Отправить» сохранённую допработу/учёбку (26.09, владелец: «сохранение отображается в
 * расстановке у ОО с возможностью потом отправить»). Сервер снимает черновик и пишет
 * каждому (POST /api/extra-work/send); здесь — отправка частями и строка итога для доски
 * в том же виде, что у рассылки расстановки.
 */
import { api } from "../api/client";

/** Сервер берёт не больше 25 строк за запрос — у воркера лимит обращений. */
const CHUNK = 25;

interface SendReply { sent?: number; released?: number; failed?: { name: string; reason: string }[] }

export async function sendExtraWork(rowIds: number[]): Promise<{ ok: boolean; msg: string }> {
  let sent = 0, released = 0;
  const failed: { name: string; reason: string }[] = [];
  try {
    for (let i = 0; i < rowIds.length; i += CHUNK) {
      const r = await api<SendReply>("/api/extra-work/send", { method: "POST", body: { ids: rowIds.slice(i, i + CHUNK) } });
      sent += r.sent ?? 0; released += r.released ?? 0; failed.push(...(r.failed ?? []));
    }
  } catch (e: unknown) {
    return { ok: false, msg: `Рассылка не выполнена${released ? ` (часть ушла: ${sent})` : ""}: ${e instanceof Error ? e.message : "ошибка"}` };
  }
  if (!released) return { ok: true, msg: "Уже отправлено раньше" };
  return { ok: true, msg: `Отправлено ${sent}${failed.length ? ` · НЕ доставлено: ${failed.map((f) => `${f.name} (${f.reason})`).join(", ")}` : ""}` };
}
